import React from 'react';
import * as S from './LoadingScreenStyles';
import { brandCompany } from '../../../../../config/constants';

const LoadingScreen = () => {
  return (
    <S.LoadingContainer>
      <div className="loader-section-message">
        <div className="circle-loader"></div>
        <p className="loading-message">
          Finding the best ride with our premium Cab Partners
        </p>
      </div>

      <div className="brand-container">
        {brandCompany?.map((brandIc, i) => {
          return (
            <S.BrandCompanyLogo
              key={'brand-company-logo' + i}
              src={brandIc}
            />
          );
        })}
      </div>
    </S.LoadingContainer>
  );
};

export default LoadingScreen;
